import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaCheckCircle, FaShieldAlt, FaHandshake, FaLightbulb, FaAward 
} from 'react-icons/fa';
import DeleteButton from '../editors/DeleteButton';

interface CoreValue {
  icon: string;
  ar: string;
  en: string;
  color: string;
}

interface AboutCoreValuesSectionProps {
  language?: 'ar' | 'en';
  values?: CoreValue[];
  onDeleteValue?: (index: number) => void;
}

const AboutCoreValuesSection: React.FC<AboutCoreValuesSectionProps> = ({
  language = 'ar',
  values = [
    { icon: "FaCheckCircle", ar: "الجودة", en: "Quality", color: "text-blue-600" },
    { icon: "FaShieldAlt", ar: "السلامة", en: "Safety", color: "text-green-600" },
    { icon: "FaHandshake", ar: "النزاهة", en: "Integrity", color: "text-purple-600" },
    { icon: "FaLightbulb", ar: "الابتكار", en: "Innovation", color: "text-yellow-600" },
    { icon: "FaAward", ar: "التميز", en: "Excellence", color: "text-red-600" },
    { icon: "FaHandshake", ar: "الشراكة طويلة الأمد", en: "Long-term Partnership", color: "text-indigo-600" }
  ],
  onDeleteValue
}) => {
  const isRTL = language === 'ar';

  const getIconComponent = (iconName: string) => {
    switch (iconName) {
      case 'FaCheckCircle': return FaCheckCircle;
      case 'FaShieldAlt': return FaShieldAlt;
      case 'FaHandshake': return FaHandshake;
      case 'FaLightbulb': return FaLightbulb;
      case 'FaAward': return FaAward;
      default: return FaCheckCircle;
    }
  };

  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <h2 className="text-3xl font-bold text-center mb-12 text-gray-900">{isRTL ? 'قيمنا الأساسية' : 'Our Core Values'}</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
          {values.map((value, idx) => {
            const IconComponent = getIconComponent(value.icon);
            return (
              <motion.div
                key={idx}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: idx * 0.1, duration: 0.5 }}
                viewport={{ once: true }}
                className="group relative bg-gradient-to-br from-gray-50 to-blue-50 rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-shadow"
              >
                {onDeleteValue && (
                  <DeleteButton onDelete={() => onDeleteValue(idx)} size="sm" />
                )}
                <IconComponent className={`w-8 h-8 mx-auto mb-4 ${value.color}`} />
                <span className="font-semibold text-gray-800 text-sm md:text-base">
                  {isRTL ? value.ar : value.en}
                </span>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AboutCoreValuesSection; 